import { Button } from '@radix-ui/themes';

function getVisiblePages(current, total) {
    if (total <= 7) {
        return Array.from({ length: total }, (_, i) => i + 1);
    }

    const pages = new Set([1, total, current, current - 1, current + 1]);
    const sorted = [...pages].filter((p) => p >= 1 && p <= total).sort((a, b) => a - b);
    const result = [];
    let prev = 0;

    for (const page of sorted) {
        if (prev && page - prev > 1) {
            result.push('…');
        }
        result.push(page);
        prev = page;
    }

    return result;
}

export default function Pagination({ pageNo, pageSize, total, setCurrectPage }) {
    const totalPages = pageSize > 0 ? Math.ceil(total / pageSize) : 0;

    if (totalPages <= 1) {
        return null;
    }

    const hasPre = pageNo > 1;
    const hasNext = pageNo < totalPages;
    const pages = getVisiblePages(pageNo, totalPages);

    return (
        <div className="redesign-pagination">
            <Button
                className="redesign-btn-secondary"
                onClick={() => setCurrectPage(pageNo - 1)}
                disabled={!hasPre}
            >
                « 上一页
            </Button>

            <div className="redesign-pagination-pages" aria-label="页码">
                {pages.map((page, index) => (
                    page === '…' ? (
                        <span key={`ellipsis-${index}`} className="redesign-pagination-ellipsis">…</span>
                    ) : (
                        <button
                            key={page}
                            type="button"
                            className={`redesign-pagination-page${page === pageNo ? ' active' : ''}`}
                            onClick={() => setCurrectPage(page)}
                            aria-current={page === pageNo ? 'page' : undefined}
                            aria-label={`第 ${page} 页`}
                        >
                            {page}
                        </button>
                    )
                ))}
            </div>

            <Button
                className="redesign-btn-secondary"
                onClick={() => setCurrectPage(pageNo + 1)}
                disabled={!hasNext}
            >
                下一页 »
            </Button>
        </div>
    );
}
